export enum AccountKeyScopes {
    Account = 'account',
    TeamsRead = 'teams.read',
    TeamsWrite = 'teams.write',
}
